import { BLOCK_TYPE } from "config/constants/editor";

export default function calculateWordCount(editorState) {
  const contentState = editorState.getCurrentContent();

  if (!contentState.hasText()) return 0;

  const blockMap = contentState.getBlockMap();
  const skippedBlocks = [
    BLOCK_TYPE.KEEP_READING,
    BLOCK_TYPE.IMAGE,
    BLOCK_TYPE.EMBED,
  ];

  return blockMap.reduce((total, block) => {
    const blockType = block.getType();

    if (skippedBlocks.includes(blockType)) return total;

    const blockText = block.getText().trim();
    const words = blockText.split(/\s+/);

    if (words.length === 1 && !words[0]) return total;

    return total + words.length;
  }, 0);
}
